import _ from 'lodash';
import moment from 'moment';

export const WHATSAPP_RESEND_TIMEOUT = 10;

export const whatsappCodeExpired = (createdDate: Date): boolean => {
  if (createdDate == null || createdDate == '') return true;
  const createdCode = new Date(createdDate);
  const expirationDate = moment(createdCode)
    .add(1, 'days')
    .format('YYYY-MM-DD HH:mm:ss');
  const nowDate = moment().format('YYYY-MM-DD HH:mm:ss');
  return nowDate >= expirationDate;
};

export const isWhatsappResendAllowed = (dateValue: any): boolean => {
  if (dateValue == null || dateValue == '') return true;
  const elapsedDate = moment(dateValue).add(WHATSAPP_RESEND_TIMEOUT, 'minutes');

  return moment().isAfter(elapsedDate);
};

export const minutesFromDate = (dateValue: any): number => {
  return (moment().unix() - moment(dateValue).unix()) / 60;
};

export const getTimeText = (hour: number, minute: number): string => {
  return `${hour}:${minute}`;
};

export const getWeekdayName = (weekday: number): string => {
  switch (weekday) {
    case 0:
      return 'Domingo';
    case 1:
      return 'Lunes';
    case 2:
      return 'Martes';
    case 3:
      return 'Miércoles';
    case 4:
      return 'Jueves';
    case 5:
      return 'Viernes';
    case 6:
      return 'Sábado';
  }
};
export const getMonthName = (month: number): string => {
  switch (month) {
    case 0:
      return 'Enero';
    case 1:
      return 'Febrero';
    case 2:
      return 'Marzo';
    case 3:
      return 'Abril';
    case 4:
      return 'Mayo';
    case 5:
      return 'Junio';
    case 6:
      return 'Julio';
    case 7:
      return 'Agosto';
    case 8:
      return 'Septiembre';
    case 9:
      return 'Octubre';
    case 10:
      return 'Noviembre';
    case 11:
      return 'Diciembre';
  }
};

export const getTranslatedMonthName = (
  month: string,
  format: string = 'MMMM'
) => {
  const validFormats = ['M', 'Mo', 'MM', 'MMM', 'MMMM'];
  if (_.includes(validFormats, format) && !_.isUndefined(month)) {
    return moment()
      .locale('en')
      .month(month)
      .locale('es')
      .format(format);
  }
  return 'Invalid format';
};

export const getShortMonthName = (month: number): string => {
  switch (month) {
    case 0:
      return 'Ene';
    case 1:
      return 'Feb';
    case 2:
      return 'Mar';
    case 3:
      return 'Abr';
    case 4:
      return 'May';
    case 5:
      return 'Jun';
    case 6:
      return 'Jul';
    case 7:
      return 'Ago';
    case 8:
      return 'Sep';
    case 9:
      return 'Oct';
    case 10:
      return 'Nov';
    case 11:
      return 'Dic';
  }
};

export const FullMonths = (): Array<string> => {
  return [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ];
};

export const WeekShortName = () => {
  return ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'];
};

export const groupBy = (arr, key) => {
  return arr.reduce((result, currentValue) => {
    const day = moment(currentValue[key]).format('DD/MM');
    if (!result[day]) result[day] = { day: day, meetings: [currentValue] };
    else result[day].meetings.push(currentValue);

    return result;
  }, {});
};
